<template>
  <div class="m-5">
    <div class="flex align-top content-start justify-end">
      <d-checkbox v-model="showOptional" @click="showOptional != showOptional" class="pr-5">
        Show Optional
      </d-checkbox>

      <d-checkbox v-model="showCompleted" @click="showCompleted != showCompleted">
        Show Completed
      </d-checkbox>
    </div>
    <div class="flex flex-wrap py-5 -mx-2">
      <template>
        <div class=" flex flex-wrap">
          <assignment-card class="w-full md:w-1/2 xl:w-1/3  " :assignment="assignment" v-for="assignment in assignments" :key="assignment.id"></assignment-card>
        </div>
      </template>
      <div class="flex justify-end w-full px-5">
        <d-pagination :total="total" :per-page="pagination.pageSize" :current="pagination.page" @change="page => pagination.page = page" />
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  import debounce from 'lodash/debounce';

  import DPagination from '@devsquared/d2kit/src/js/elements/DPagination/DPagination.vue';
  import AssignmentCard from './AssignmentCard.vue';

  export default {
    parent: true,
    components: {
      DPagination,
      AssignmentCard
    },
    props: {
      user: {
        type: Object,
        default: () => { },
      },
      filter: {
        type: String,
        default: () => '',
      },
    },
    data: () => ({
      assignments: [],
      loadingAssignments: false,
      showCompleted: false,
      showOptional: false,
      total: 0,
      pagination: {
        page: 1,
        pageSize: 18,
        sortField: 'updatedAt',
        sortOrder: 'desc',
      },
    }),

    computed: {
      ...mapGetters('d2Auth', ['hasRole']),
    },
    watch: {
      pagination: {
        handler() {
          this.getAssignmentsPaged();
        },
        deep: true,
      },
      filter() {
        this.getAssignmentsPaged();
      },
      showCompleted() {
        this.getAssignmentsPaged();
      },
      showOptional() {
        this.getAssignmentsPaged();
      }
    },
    mounted() {
      this.getAssignmentsPaged();
    },

    methods: {
        getAssignmentsPaged : debounce(async function ()  {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [
          `currentPage=${page}`,
          `pageSize=${pageSize}`,
          `filter=${this.filter}`,
          `showCompleted=${this.showCompleted}`,
          `showOptional=${this.showOptional}`,
          `sortDir=${sortField} ${sortOrder}`,
        ].join('&');
        this.loadingAssignments = true;
        try {
          const { data } = await axios.get(`/api/consultant-reviewer/assignments/paged?${params}`);
          this.assignments = data.resultItems;
          this.total = data.totalRecords;
          this.loadingAssignments = false;
        } catch (error) {
          this.$toast.open({
            message: error.message,
            color: 'red-500',
            duration: 4000,
          });
          this.loadingAssignments = false;
        }
      }, 1000),
    },
  };
</script>